import { useMemo } from 'react';

import { SJDatabase } from '../core';
import { useCollectionsStatusStore } from '../stores/collectionsStatus.store';
import { useSecureJsonCollectionsStore } from '../stores/secureJsonCollections.store';

export const useSJDatabase = (): SJDatabase => {
  const [awaitInited, colStatus] = useCollectionsStatusStore((s) => [s.awaitInited, s.status]);
  const [collections, changeCollectionItem] = useSecureJsonCollectionsStore((s) => [
    s.collections,
    s.changeCollectionItem,
  ]);

  return useMemo(() => {
    return new SJDatabase(collections, colStatus === 'inited', awaitInited, changeCollectionItem);
  }, [collections, colStatus]);
};
